import { Navigate, Route, Routes } from "react-router-dom";

import PaymentsLedgerPage from "./pages/PaymentsLedgerPage";

/**
 * Sub-router for `/app/payments-ledger/*`.
 *
 * The bare route is the browse state; `/:operationKind/:operationId` is the linkable one, which is what the
 * payments-activity drawer and the wallet statement point at. The page validates both params, so an unknown
 * kind or a malformed id renders as "nothing selected" rather than firing a request the API would reject.
 */
export const PaymentsLedgerNavigation = () => {
  return (
    <Routes>
      <Route index element={<PaymentsLedgerPage />} />
      <Route path=":operationKind/:operationId" element={<PaymentsLedgerPage />} />
      <Route path="*" element={<Navigate to="/app/payments-ledger" replace />} />
    </Routes>
  );
};
